export default "__VITE_ASSET__DtXKoX5X__"